import { api } from '@/shared';
import type { ApiResponse } from '@/shared/types/api';

export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export interface ContactFormResponse {
  id: string;
  createdAt: string;
}

/**
 * Submit contact form
 */
export const submitContactForm = async (
  data: ContactFormData,
): Promise<ApiResponse<ContactFormResponse>> => {
  const response = await api.post<ApiResponse<ContactFormResponse>>(
    `/contact/submit`,
    data,
  );
  return response;
};